import { getFormatValue } from '../listingDetails/price_utils';

export const getCardPriceData = ({ daysAmount, price, t }) => {
  const hasPrice = daysAmount && price && !!price?.regular?.totalPrice;
  const hasDiscount =
    hasPrice && price?.discount?.totalPrice < price?.regular?.totalPrice;
  const currencyTranslation = t(`${price?.currency}`, price?.currency || '');

  const totalMoneyValue = getFormatValue(
    price?.regular?.price,
    currencyTranslation
  );
  const discountedMoneyValue = getFormatValue(
    price?.discount?.price,
    currencyTranslation
  );

  return { hasPrice, hasDiscount, totalMoneyValue, discountedMoneyValue };
};
